import { render, staticRenderFns } from "./Pricep.vue?vue&type=template&id=41ec0a74&"
import script from "./Pricep.vue?vue&type=script&lang=js&"
export * from "./Pricep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports